import { createMongoAbility, MongoAbility } from '@casl/ability'
import { useSelector } from 'react-redux'

const useAbilityStore = (): MongoAbility => {
  const abilityInstance = useSelector(
    (state: { global: { ability: MongoAbility } }) => state?.global?.ability
  )

  return (abilityInstance || createMongoAbility([]))
}

export default useAbilityStore
